import * as React from 'react'
import cx from 'classnames'
import { IconWrapper, IconProps, sizes } from '../../IconWrapper'
export const ForkKnifeIcon = React.forwardRef(function ForkKnifeIcon(
  props: IconProps,
  ref?: React.ForwardedRef<HTMLElement>
) {
  return (
    <IconWrapper ref={ref} {...props}>
      <>
        {
          <svg
            width={24}
            height={24}
            viewBox='0 0 24 24'
            fill='none'
            className={cx(
              'inline-block align-middle',
              sizes[props.size || 'sm'].className
            )}
          >
            <path
              d='M15.117 14.79L22 7.907M10.012 9.639l6.86-6.86m-3.23 6.739l4.955-4.954M15.36 11.1l4.954-4.954M3.43 19.72l4.2-4.2m-2.1 5.58l4.048-4.05m7.548 4.171l-4.308-4.462a1.39 1.39 0 00-1.98 0 1.275 1.275 0 01-1.816-.084l-5.485-5.484a5.25 5.25 0 010-7.425L19.49 19.72'
              stroke='currentColor'
              strokeWidth={sizes[props.size || 'sm'].strokeWidth}
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        }
      </>
    </IconWrapper>
  )
})
